"use client";

import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeRaw from 'rehype-raw';
import rehypeStringify from 'rehype-stringify';

/**
 * Convert Markdown into HTML suitable for TipTap insertContent().
 * Handles basic markdown, GFM (tables, task lists), and raw HTML.
 */
export async function mdToHtml(markdown: string): Promise<string> {
  const file = await unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkRehype, { allowDangerousHtml: true })
    .use(rehypeRaw) // allow raw HTML inside markdown
    .use(rehypeStringify)
    .process(markdown);
  return String(file);
}